module.exports = __webpack_public_path__ + "static/media/appProfile.c57c5860.png";